import type { MutableState } from '../State';
import { getPuzzleWinsLast7Days } from './puzzleWinCount.getters';

/**
 * Increment the puzzle win count by 1
 * @param state User state
 * @param now Current time
 */
export function incrementPuzzleWinCount(
  state: MutableState,
  now: number,
): void {
  // Retrieve the current history based on the current time
  const history = getPuzzleWinsLast7Days(state, now);

  // Increment the current day
  if (!history[0]) history[0] = 0;
  history[0] += 1;
  // Save the updated history
  state.puzzleWinCount.days = history;
  state.puzzleWinCount.updatedAt = now;
}
